import { useTranslation } from "react-i18next";

const LandingPage = () => {
    const [translate] = useTranslation();

    return <label className="mt-3 ms-3 h6">
        {translate("OTM_LANDING_TEXT")}
    </label>
}

export default LandingPage;